import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import files from './filesPage/handler';

export default pipeHandlers(common, files);
